import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const Footer = () => (
  <footer className="bg-[#050505] text-white pt-24 pb-10 px-6" data-testid="main-footer">
    <div className="max-w-7xl mx-auto">
      <div className="grid md:grid-cols-12 gap-12 pb-20 border-b border-white/10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2.5 mb-6">
            <span className="h-2.5 w-2.5 rounded-full" style={{ background: "var(--gold)" }} />
            <span className="text-xl font-semibold tracking-tight">VELIORA</span>
          </div>
          <h3 className="text-3xl sm:text-4xl tracking-tight leading-tight max-w-md">
            Zbudujmy system, który <span className="font-serif-italic" style={{ color: "var(--gold)" }}>rozwija</span> Twój biznes.
          </h3>
          <Link to="/contact" data-testid="footer-cta" className="group inline-flex items-center gap-2 mt-8 text-lg">
            <span className="border-b border-white/30 group-hover:border-white transition-colors">Umów bezpłatną konsultację</span>
            <ArrowUpRight size={20} className="transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
          </Link>
        </div>

        <div className="md:col-span-2 md:col-start-8">
          <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Nawigacja</p>
          <ul className="space-y-3 text-white/70">
            {[["Strona główna","/"],["Usługi","/services"],["Portfolio","/portfolio"],["O nas","/about"],["Kontakt","/contact"]].map(([label, href]) => (
              <li key={href}><Link className="hover:text-white transition-colors" to={href}>{label}</Link></li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-2">
          <p className="text-xs uppercase tracking-[0.2em] text-white/40 mb-5">Kontakt</p>
          <ul className="space-y-3 text-white/70">
            <li><a className="hover:text-white transition-colors" href="mailto:veliora.kontakt.pl@gmail.com">veliora.kontakt.pl@gmail.com</a></li>
            <li><a className="hover:text-white transition-colors" href="tel:+48519615441">+48 519 615 441</a></li>
            <li><span>Polska • współpraca online</span></li>
          </ul>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row justify-between items-center gap-4 pt-8 text-sm text-white/40">
        <p>© {new Date().getFullYear()} Veliora. Technologia, która napędza wzrost.</p>
        <div className="flex gap-6">
          <a href="#" className="hover:text-white transition-colors">Prywatność</a>
          <a href="#" className="hover:text-white transition-colors">Regulamin</a>
          <a href="#" className="hover:text-white transition-colors">LinkedIn</a>
        </div>
      </div>
    </div>
  </footer>
);
